<template>
  <div id="formLogin">
    <el-form
      :model="user"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item prop="username">
        <el-input
          v-model="user.username"
          placeholder="请输入手机号"
          class="eb-input"
        >
          <i
            slot="prepend"
            class="icon iconfont icon-shouji"
          ></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="user.password"
          placeholder="请输入密码"
          class="eb-input"
        >
          <i
            slot="prepend"
            class="icon iconfont icon-mima"
          ></i>
        </el-input>
      </el-form-item>

      <el-button
        id="loginBtn"
        class="loginBtn"
        @click="submitForm('ruleForm')"
      >登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
      <div class="login-bottom">
        <div class="wxLogin_link">
          <span class="wxLogin_link_findPass"></span>
          <span
            class="wxLogin_link_findPass_btn"
            @click="onFindPass"
          >忘记密码</span>
          <span class="wxLogin_link_register"></span>
          <a
            class="wxLogin_link_register_btn"
            @click="toRegister"
          >免费注册</a>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
// import Cookies from 'js-cookie';
import $ from 'jquery';
import eventBus from '@/plugins/event-bus';
import { login } from '@/services/user/user-service';
export default {
  name: 'formLogin',
  data() {
    return {
      user: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ validator: this.checkUserName, trigger: 'blur' }],
        password: [{ validator: this.checkPassWord, trigger: 'blur' }]
      }
    };
  },
  mounted() {
    $(document).bind('keydown', function(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        $('#loginBtn').click();
      }
    });
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loginService();
        } else {
          return false;
        }
      });
    },
    async loginService() {
      try {
        let { data } = await login(this.user.username, this.user.password);
        if (data.returnCode === '01') {
          this.$emit('onLoginSuccess', data);
        } else if (data.returnCode === '00') {
          this.$message.error('用户名或密码错误');
        } else if (data.returnCode === '05') {
          if (data.errorCode === '01') {
            this.$message.error('您的注册申请已提交。运营方审核完成后，将向您发送短信与邮件通知，请注意关注。');
          } else if (data.errorCode === '02') {
            this.$message.error(
              '您输入密码错误次数过多，为保护密码安全，您的账户将被锁定一小时。请您一小时之后再登录，或使用找回密码功能，重新设置您的密码。'
            );
          } else if (data.errorCode === '03') {
            this.$message.error('此账号被停止使用，请与贵方机构管理员联系。');
          } else if (data.errorCode === '04') {
            this.$message.error('您所在机构已被禁止登录，请联系易比得合规采购平台了解详情。');
          } else {
            this.$message.error('未知错误');
          }
        } else if (data.returnCode === '03') {
          this.$message.error('用户名与密码不能为空');
        } else if (data.returnCode === '502') {
          location.href = '/error/502';
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    checkUserName: function(rule, value, callback) {
      this.user.username = ('' + this.user.username).replace(/\s/g, '');
      if (!this.user.username) {
        return callback(new Error('请输入用户名'));
      }
      if (!parseInt(this.user.username)) {
        return callback(new Error('请输入正确手机号'));
      }
      this.user.username = parseInt(this.user.username);
      if (('' + this.user.username).length !== 11) {
        return callback(new Error('请输入11位手机号'));
      }
      callback();
    },
    checkPassWord: function(rule, value, callback) {
      this.user.password = ('' + this.user.password).replace(/\s/g, '');
      if (!this.user.password) {
        return callback(new Error('请输入密码'));
      }
      callback();
    },
    onFindPass: function() {
      eventBus.$emit('isFindPassShow', true);
    },
    toRegister: function() {
      // Cookies.remove('orgRegisterData');
      sessionStorage.removeItem('orgRegisterData');
      this.$router.push('/org/register/stepone');
    }
  }
};
</script>
<style lang="less">
#formLogin {
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 13px;
    background: #f8f7f8;
    border-radius: 0;
  }
  .el-input__inner {
    height: 40px;
    border-radius: 0;
  }
  .loginBtn {
    width: 100%;
    background-color: #e4393c;
    border: 1px solid #e85356;
    margin-top: 23px;
    text-align: center;
    cursor: pointer;
    border-radius: 0;
    color: #fff;
    font-size: 20px;
    font-family: 'Microsoft YaHei';
    height: 33px;
    line-height: 31px;
    padding: 0;
  }
  .login-bottom {
    padding-top: 16px;
  }
  .wxLogin_link {
    margin-left: 40px;
    font-family: 'microsoft yahei';
    color: #999;
    line-height: 25px;
    .wxLogin_link_findPass {
      padding: 3px 13px;
      background: url('../../assets/img/qr-coagent.png') no-repeat;
      margin-right: 5px;
    }
    .wxLogin_link_findPass_btn {
      cursor: pointer;
    }
    .wxLogin_link_register {
      padding: 3px 13px;
      background: url('../../assets/img/qr-coagent.png') -27px 0px no-repeat;
      margin-right: 5px;
      margin-left: 42px;
    }
    .wxLogin_link_register_btn {
      cursor: pointer;
      color: #999;
    }
  }
}
</style>
